module.exports = __webpack_public_path__ + "img/icon_trial_success_7.00b72a9c.png";